import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { getCurrentUser } from '../../publicSession/selectors';
import { getCurrentItem } from '../../Duperbrowse/redux/selectors';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { ResourceType } from '../../types/resource';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
export function useSafeUrlHandler() {
    var _currentDeviation_author;
    const dispatch = useDispatch();
    const currentUser = useSelector(getCurrentUser);
    const currentDeviation = useSelector(getCurrentItem);
    const logBiEvent = useBiLogger();
    const safeUrlHandler = useCallback((e)=>{
        var _currentDeviation_author;
        if (currentUser.userId === (currentDeviation === null || currentDeviation === void 0 ? void 0 : (_currentDeviation_author = currentDeviation.author) === null || _currentDeviation_author === void 0 ? void 0 : _currentDeviation_author.userId)) {
            return;
        }
        const clickedEl = e.target;
        // Closest is inclusive of the target, and should be safe as
        // we cant have anchor inside anchor.
        const anchor = clickedEl.closest('a');
        if (anchor) {
            var _anchor_getAttribute;
            let href = (_anchor_getAttribute = anchor.getAttribute('href')) !== null && _anchor_getAttribute !== void 0 ? _anchor_getAttribute : '';
            href = href.replace(/^https?:\/\/www\.deviantart\..*\/users\/outgoing\?/i, '');
            if (!/^https?:\/\/.*deviantart\..*\//.test(href) && !/^https?:\/\/.*sta\.sh/.test(href) && !/^https?:\/\/.*dreamup\.com\.\..*\//.test(href) && !/^https?:\/\/.*deviantartsell\.com/.test(href) && !/^https?:\/\/.*deviantartsupport\.com/.test(href) && !/^https?:\/\/.*fav\.me/.test(href) && !/^#/.test(href)) {
                e.preventDefault();
                e.stopPropagation();
                var _currentDeviation_deviationId;
                logBiEvent(BiData({
                    evid: 364,
                    link_url: href,
                    sectionname: BiContextProvidedValue,
                    itemid: (_currentDeviation_deviationId = currentDeviation === null || currentDeviation === void 0 ? void 0 : currentDeviation.deviationId) !== null && _currentDeviation_deviationId !== void 0 ? _currentDeviation_deviationId : 0,
                    typeid: ResourceType.DEVIATION
                }));
                dispatch(pushModal(ModalType.SAFE_URL, {
                    params: {
                        href
                    },
                    wrapInModal: false
                }));
            }
        }
    }, [
        currentDeviation === null || currentDeviation === void 0 ? void 0 : (_currentDeviation_author = currentDeviation.author) === null || _currentDeviation_author === void 0 ? void 0 : _currentDeviation_author.userId,
        currentDeviation === null || currentDeviation === void 0 ? void 0 : currentDeviation.deviationId,
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId,
        dispatch,
        logBiEvent
    ]);
    return safeUrlHandler;
}

//# sourceMappingURL=useSafeUrlHandler.js.map